import { render, staticRenderFns } from "./ModalChoosePlace.vue?vue&type=template&id=57bdf109&"
import script from "./ModalChoosePlace.vue?vue&type=script&lang=js&"
export * from "./ModalChoosePlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports